export default __webpack_public_path__ + "static/media/tick.bcfe9cfa.svg";